import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";

import { HomeContentWidgetExtended } from "./content-widget.model";

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: "article[obg-m-content-widget]",
	templateUrl: "./content-widget.component.html",
	styleUrls: ["./content-widget.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class ContentWidgetComponent {
	@HostBinding("class.obg-m-content-widget") hostCssClass = true;

	@HostBinding("class.obg-m-content-widget-alt")
	@Input()
	set alternativeView(value: boolean) {
		this._alternativeView = coerceBooleanProperty(value);
	}
	get alternativeView(): boolean {
		return this._alternativeView;
	}

	@Input() contentWidget: HomeContentWidgetExtended | undefined;

	private _alternativeView = false;
}
